module.exports = __webpack_public_path__ + "static/img/285_TO8_2434.46c93e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/285_TO8_2434.jpg
// module id = Zdm/
// module chunks = 0